import React from 'react';
import PropTypes from 'prop-types';
import {Tab, TabsNavigation} from '@/components/atoms';
import {PageHeader} from '@/components/molecules';
import {
  DisplayContentTab,
  PageContent,
  UploadMedia
} from '@/components/organisms';
import {Constants} from '@/utils/constants/commonConstants';

const DisplayContent = ({
  displayContentFormData,
  setDisplayContentFormData,
  mediaCardFormData,
  setMediaCardFormData,
  MediaCardUiSchema,
  languages,
  handleTabClick,
  activeLanguage,
  targetType,
  errorMessage
}) => {
  return (
    <>
      <PageContent
        className='sales-target-component bg-neutral-800 text-white'
        pageContentWrapperClassName='relative'>
        <div className='flex items-center justify-between'>
          <PageHeader title={'Display Content'} />
        </div>
        <TabsNavigation
          className='display-content-nav mb-6 w-full border-b border-gray-700'
          activeTabIndex={0}
          handleSetActiveTab={function Qa() {}}>
          {languages &&
            languages?.length > 0 &&
            languages.map((lang, idx) => (
              <Tab
                key={`${idx}_${lang.code}`}
                label={lang.title}
                className='no-icon'
                onClick={() => handleTabClick(lang.code)}
                isDark
              />
            ))}
        </TabsNavigation>

        <DisplayContentTab
          displayContentFormData={displayContentFormData}
          setDisplayContentFormData={(data) => setDisplayContentFormData(data)}
          activeLanguage={activeLanguage}
          languages={languages}
          targetType={targetType}
        />
      </PageContent>
      <PageContent
        className='sales-target-component bg-neutral-800 text-white'
        pageContentWrapperClassName='relative'>
        <UploadMedia
          mediaCardFormData={mediaCardFormData}
          setMediaCardFormData={setMediaCardFormData}
          uploadFor={Constants.SalesTarget}
          MediaCardUiSchema={MediaCardUiSchema}
          title='Target Card'
          label='Target Display*'
          fileType='image'
        />
        {errorMessage ? (
          <span className='error'>
            You must select one Foreground and one Background image.
          </span>
        ) : null}
      </PageContent>
    </>
  );
};

DisplayContent.propTypes = {
  displayContentFormData: PropTypes.object.isRequired,
  setDisplayContentFormData: PropTypes.func.isRequired,
  mediaCardFormData: PropTypes.object.isRequired,
  setMediaCardFormData: PropTypes.func.isRequired,
  MediaCardUiSchema: PropTypes.object.isRequired,
  languages: PropTypes.array.isRequired,
  handleTabClick: PropTypes.func.isRequired,
  activeLanguage: PropTypes.string,
  targetType: PropTypes.string,
  errorMessage: PropTypes.string
};

export default React.memo(DisplayContent);
